export default __webpack_public_path__ + "static/media/pvilla5-4.5689c93c.webp";